import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, hasRole } from './lib/auth.jsx';
import Login from './pages/Login.jsx';
import { AppShell } from './components/AppShell.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Clients from './pages/Clients.jsx';
import Articles from './pages/Articles.jsx';
import Categories from './pages/Categories.jsx';
import Company from './pages/Company.jsx';
import Series from './pages/Series.jsx';
import Vat from './pages/Vat.jsx';
import Currencies from './pages/Currencies.jsx';
import Users from './pages/Users.jsx';
import Placeholder from './pages/Placeholder.jsx';

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!hasRole(user, 'ADMIN')) return <Placeholder title="Forbidden" note="Admins only." />;
  return children;
}

export default function App() {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-shell"><span className="spinner" /></div>;
  if (!user) return <Login />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/invoices" element={<Placeholder title="Invoices" note="Phase 5." />} />
        <Route path="/quotes" element={<Placeholder title="Quotes" note="Phase 7." />} />
        <Route path="/proformas" element={<Placeholder title="Proformas" note="Phase 7." />} />
        <Route path="/credit-notes" element={<Placeholder title="Credit Notes" note="Phase 6." />} />
        <Route path="/payments" element={<Placeholder title="Payments" note="Phase 6." />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/reports" element={<Placeholder title="Reports" note="Phase 10." />} />
        <Route path="/settings/company" element={<AdminOnly><Company /></AdminOnly>} />
        <Route path="/settings/series" element={<AdminOnly><Series /></AdminOnly>} />
        <Route path="/settings/vat" element={<AdminOnly><Vat /></AdminOnly>} />
        <Route path="/settings/currencies" element={<AdminOnly><Currencies /></AdminOnly>} />
        <Route path="/settings/users" element={<AdminOnly><Users /></AdminOnly>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
